import Coborrower from '../../cards/coborrower';
import Cohabitate from '../../cards/cohabitation';
import { Branch, Card } from '../../components/deck';
import employmentBranch from './employment';
import firstTimeBuyer from './first-time-buyer';
import ownershipBranch from './ownership';

export default (continuation) =>
  Card(
    Coborrower,
    Branch(
      {
        coborrower: Card(
          Cohabitate,
          employmentBranch(
            'coborrower',
            firstTimeBuyer(
              'coborrower',
              Branch({ livesApart: ownershipBranch('coborrower') }, ({ model }) =>
                model.getIn(['coborrower', 'cohabitate']) ? null : 'livesApart'
              )
            )
          )
        )
      },
      ({ model }) => (model.getIn(['loan', 'hasCoborrower']) ? 'coborrower' : null),
      continuation
    )
  );



// WEBPACK FOOTER //
// ./src/decks/branches/coborrower.js